<template>
	<div class="history-bg" style="padding: 0; height: 100%; width: 100%; position: relative">
		<div class="" id="sqDb" style="height: 100%; width: 100%"></div>
	</div>
</template>

<script>
	import * as echarts from "echarts";
	import "echarts-gl";
	export default {
		data() {
			return {
				interVal: "",
				myChart: null,
				app: {
					currentIndex: -1,
				},
				dispatchTimer: null,
				dataLen: null,
			};
		},
		mounted() {
			// this.requestData(500)
			// this.generateRecentWeekDates()
			this.init(['1号地','2号地','3号地','4号地'],["55", "48", "52", "44"],["2.9", "3.4", "3.1", "3.8"],2);
		},
		methods: {
			generateRecentWeekDates() {
				const dates = [];
				const today = new Date();
				// 获取六天前的日期作为起始点
				const startDate = new Date(today);
				startDate.setDate(today.getDate() - 6);

				// 循环7天，逐日递增
				for (let i = 0; i < 7; i++) {
					const currentDate = new Date(startDate);
					currentDate.setDate(startDate.getDate() + i);

					// 格式化为MM-DD
					const month = String(currentDate.getMonth() + 1).padStart(2, "0");
					const day = String(currentDate.getDate()).padStart(2, "0");
					dates.push(`${month}-${day}`);
				}

				return dates;
			},
			requestData(number, area, tulongNum, beforeMoney, afterMoney) {
				this.$request(
					"center/newService1/farmLines?num=" +
					number +
					"&area=" +
					area +
					"&tulongNum=" +
					tulongNum +
					"&beforeMoney=" +
					beforeMoney +
					"&afterMoney=" +
					afterMoney
				).then((res) => {
					if (this.myChart) {
						clearInterval(this.dispatchTimer);
						this.myChart.clear();
					}
					for (var i = 0; i < res.data.length; i++) {
						if (res.data[i].type == 1) {
							this.init(res.data[i].list);
						}
					}
				});
			},
			init(name,data1,data2,type) {
				let that = this;
				that.myChart = echarts.init(document.getElementById("sqDb"));

				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					that.myChart.resize();
				});

				var option = {
					grid: {
						left: 20,
						right: 20,
						top: 30,
						bottom: 0,
						containLabel: true,
					},
					toolbox: {
						// feature: {
						//     saveAsImage: { // 显示保存为图片的按钮
						//         show: true, // 是否显示该工具
						//         title: '下载', // 按钮的文字提示
						//         top: '18%',
						//         width:12,
						//         height:14,
						//         right: '15%',
						//         // iconStyle:{
						//         //     color:'#fff'
						//         // }

						//     }
						// }
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow',
						},
						// formatter: function(params) {
						// 	return params[0].data.name + ' : ' + params[0].data.value + '台';
						// },
					},
					legend: {
						show: true,
						y: 0,
						textStyle: {
							color: '#fff',
							fontSize: 14,
						},
						itemWidth: 24,
						itemHeight: 12,
						//   data: ['农机数量'],
					},
					xAxis: {
						show: true,
						type: 'category',
						data: name,
						axisLine: {
							show: true,
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.2)',
								type: 'solid'
							},
						},
						splitLine: {
							show: false,
						},
						axisLabel: {
							color: '#FFF',
							fontSize: 14,
						},
						axisTick: {
							show: false,
						},
					},
					yAxis: [{
						type: 'value',
						name: '含水量(%)',
						nameTextStyle: {
							color: '#fff',
						},
						axisLabel: {
							show: true,
							margin: 10, //右侧y轴数字的外边距
							textStyle: {
								fontSize: 14,
								fontWeight: 700,
								color: 'rgba(255,255,255,1)',
							},
							formatter: (value) => {
								return value
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: 'rgba(233, 249, 248, 0.2)',
								type: 'dashed'
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: 'rgba(233, 249, 248, 0.2)',
							},
						},
					}, {
						type: 'value',
						name: '蒸腾量',
						nameTextStyle: {
							color: '#fff',
						},
						axisLabel: {
							show: true,
							margin: 10, //右侧y轴数字的外边距
							textStyle: {
								fontSize: 14,
								fontWeight: 700,
								color: 'rgba(255,255,255,1)',
							},
							formatter: (value) => {
								return value
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: 'rgba(233, 249, 248, 0.2)',
								type: 'dashed'
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: 'rgba(233, 249, 248, 0.2)',
							},
						},


					}],
					series: [{
							name: type == 2 ? '去年含水量' : '今年含水量',
							type: 'bar',
							zlevel: 1,
							showBackground: true,
							label: {
								show: false,
							},
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
											offset: 1,
											color: 'rgba(171, 214, 255, 1)',
										},
										{
											offset: 0,
											color: 'rgba(55, 158, 255, 1)',
										},
									]),
								},
							},
							barWidth: 15,
							data: data1,
						},
						// {
						// 	name: '2',
						// 	type: 'bar',
						// 	zlevel: 1,
						// 	showBackground: true,
						// 	label: {
						// 		show: false,
						// 	},
						// 	itemStyle: {
						// 		normal: {
						// 			color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
						// 					offset: 0,
						// 					color: 'rgba(255, 246, 0, 1)',
						// 				},
						// 				{
						// 					offset: 1,
						// 					color: 'rgba(255, 252, 162, 1)',
						// 				},
						// 			]),
						// 		},
						// 	},
						// 	barWidth: 15,
						// 	data: datas,
						// },
						{
							name:type == 2 ? '去年蒸腾量' : '今年蒸腾量',
							type: 'line',
							symbol: 'circle',
							lineStyle: {
								width: 2,
							},
							itemStyle: {
								color: 'rgba(255, 246, 0, 1)',
							},
							yAxisIndex: 1,
							data: data2
						}
					],
				};


				that.dataLen = option.series[0].data.length;
				// that.dispatchActions()

				that.myChart.setOption(option);
				// this.interVal = setInterval(function () {
				//     that.myChart.clear()
				//     that.myChart.setOption(option);
				// }, 240000)
				// 20000
			},
			dispatchActions() {
				let that = this;
				that.dispatchTimer = setInterval(function() {
					// 取消之前高亮的图形
					that.myChart.dispatchAction({
						type: "downplay",
						seriesIndex: 0,
						dataIndex: that.app.currentIndex,
					});
					that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
					//console.log(app.currentIndex);
					// 高亮当前图形
					that.myChart.dispatchAction({
						type: "highlight",
						seriesIndex: 0,
						dataIndex: that.app.currentIndex,
					});
					// 显示 tooltip
					that.myChart.dispatchAction({
						type: "showTip",
						seriesIndex: 0,
						dataIndex: that.app.currentIndex,
					});
				}, 3000);
			},
			clearDispatchTimer() {
				clearInterval(this.dispatchTimer);
			},
			setDispatchTimer() {
				this.dispatchActions();
			},
		},
		destroyed() {
			clearInterval(this.interVal);
		},
	};
</script>

<style>
</style>